export let GlobalVariable = {
  title: 'MyVisit易访',
  imgUrl: {
    homeBannerUrl: 'assets/imgs/amd_home.png',
    loginBannerUrl: 'assets/imgs/menu-logo.png'
  },  // 系统的图片
  libraryMinApplication: 'http://library.xiaosk.com/read',  // 资料小程序地址(观看地址不是分享地址)
  mapApiKey: 'de82edae47fe09a620b1666ec901d228',
  gestureResumeTime: 60000,   // app手势唤醒的时长
  noticeIsShow: false,  // 是否显示公告栏提示
  isDebugConsole: true, // 是否显示vConsole
  isCanChangePassword: false,  // 是否能修改移动端和PC端代码
  loadingIsShow: false,
  alertingIsShow: false,
  alertingMessage: '',
  authenticationStatus: {
    message: '',
    status: 'landing',
    policy: ''
  },
  currentAccountInfo: {
    selectedTerritory: {
      territoryId: '',
      territoryName: '',
      count: 0
    },  // 当前登录选择的岗位 {territoryId: '', territoryName: ''}
    staffName: '',  // 人员名
    staffId: '',    // 人员ID
    userId: '',
    territoryItems: [],   // 当前用户拥有的岗位 [{territoryId:'',  territoryName:''}]
    permissions: []    // 当前用户拥有的权限 ['string']
  },
  deviceInfo: { // 终端硬件信息
    name: '' // ios/android
  },
  selectedUnderlingStaff: {
    staffId: '',
    staffName: '',
    territoryId: '',
    territoryName: '',
    territoryLevel: '',
  },
  isTestWeChat: false,
  rsaPublickKey: ''
};
